import classnames from 'classnames';
import React, { ReactElement } from 'react';
import { Control, Controller, FieldName } from 'react-hook-form';
import { PLEASE_SELECT_OPTION } from '../../../constants/form';
import { MultipleSelect, MultipleSelectOption } from '../../MultipleSelect';
import styles from '../ControlledSelect/ControlledSelect.module.css';

export interface ControlledMultipleSelectProps<
  T extends Record<string, unknown>,
> {
  className?: string;
  control: Control;
  defaultValue?: string[];
  error?: string;
  horizontal?: boolean;
  label: string;
  labelClass?: string;
  name: FieldName<T>;
  options: MultipleSelectOption[];
  required?: boolean;
  testId?: string;
  id?: string;
  customOnChange?: (value: string[]) => string[] | void;
  formGroupTextClass?: string;
  disabled?: boolean;
  placeholder?: string;
  onOpenChange?: (isOpen: boolean) => void;
}

export const ControlledMultipleSelect = <T extends Record<string, unknown>>({
  className,
  control,
  defaultValue = [],
  error,
  disabled,
  formGroupTextClass,
  horizontal = false,
  id,
  label,
  labelClass = '',
  name,
  options,
  placeholder = PLEASE_SELECT_OPTION.name,
  required = false,
  testId,
  customOnChange,
  onOpenChange,
}: ControlledMultipleSelectProps<T>): ReactElement => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ onChange, onBlur, value }) => (
        <MultipleSelect
          label={label}
          labelClass={classnames(labelClass, 'half-margin-bottom')}
          errors={error ? [error] : undefined}
          onChange={(selectedValues) => {
            onChange(customOnChange?.(selectedValues) ?? selectedValues);
          }}
          onBlur={onBlur}
          value={value ?? []}
          required={required}
          options={options}
          placeholder={placeholder}
          horizontal={horizontal}
          formGroupTextClass={formGroupTextClass}
          testId={testId}
          className={classnames(styles.select, className)}
          id={id ?? name}
          disabled={disabled}
          onOpenChange={onOpenChange}
        />
      )}
    />
  );
};
